<form [formGroup]="form" (ngSubmit)="onSave()">
  <div p-dialog-content>
    <div>
      <p-divider align="left">
        <div class="inline-flex align-items-center">
          <b>Item settings</b>
        </div>
      </p-divider>
      <div class="grid">
        <div class="col">
          <label class="block font-bold mb-2" for="url">Name</label>
          <input
            inputId="url"
            type="text"
            pInputText
            class="w-full p-inputtext"
            formControlName="name"
          />
        </div>
        <div class="col" style="flex-grow: 0;">
          <label class="block font-bold mb-2">Target</label>
          <p-select formControlName="category" [options]="['Evidence', 'POAM']" appendTo="body"></p-select>
        </div>
        <div class="col">
          <label class="block font-bold mb-2" for="type">Type</label>
          <input
            inputId="type"
            type="text"
            pInputText
            class="w-full p-inputtext"
            formControlName="type"
          />
        </div>
        <div class="col">
          <label class="block font-bold mb-2" for="url">Notes</label>
          <input
            inputId="url"
            type="text"
            pInputText
            class="w-full p-inputtext"
            formControlName="notes"
          />
        </div>
        <div class="col" style="flex-grow: 0;">
          <label class="block font-bold mb-2">Source</label>
          <div style="display: flex; flex-direction: row;">
            <i class="pi pi-paperclip" [ngStyle]="{opacity: isIntegration ? 0.5 : 1}"
               (click)="isIntegration = false; inputFile.click()"
               matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}">
            </i>
            <input #inputFile
                   type="file"
                   accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                   (change)="selectAttachment($event)"
                   [style.display]="'none'">
            <i class="pi pi-cloud-download" (click)="isIntegration = true"
               [ngStyle]="{opacity: !isIntegration ? 0.5 : 1}" style="margin-right: 20px; margin-left: 10px;"></i>
            <span *ngIf="!isIntegration && fileContent">{{ fileName }}</span>
          </div>
        </div>
        <div *ngIf="isIntegration" class="col">
          <label class="block font-bold mb-2" for="integrationId">Integration</label>
          <p-select formControlName="integrationId" [options]="integrations" optionValue="id" appendTo="body"
                      optionLabel="name"></p-select>
        </div>
      </div>
      <div class="grid">
        <div class="col">
          <label class="block font-bold mb-2">Inspection Profile</label>
          <p-select formControlName="inspectionProfileId" [options]="inspections" optionValue="id" appendTo="body"
                      optionLabel="name"></p-select>
        </div>
        <div class="col">
          <label class="block font-bold mb-2">Target Controls <i class="pi pi-plus"
                                                                 (click)="addProjectControlItem()"></i></label>
          <div><span *ngFor="let item of selectedProjectControlItems">{{ item.projectName }}
            - {{ item.complianceAreaControlId }} <i class="pi pi-trash cursor-pointer"
                                                    (click)="removeProjectControlItem(item)"></i></span></div>
        </div>
        <div class="col">
          <label class="block font-bold mb-2">Target Devices <i class="pi pi-plus"
                                                                 (click)="addDevice()"></i></label>
          <div><span *ngFor="let item of selectedDevices">{{item.clientITProfileName}} - {{ item.deviceName }} <i class="pi pi-trash cursor-pointer"
                                                    (click)="removeDevice(item)"></i></span></div>
        </div>
        <div class="col" style="flex-grow: 0;">
          <label class="block font-bold mb-2">Owner(s)</label>
          <p-select formControlName="ownerId" [options]="users" optionValue="userId" appendTo="body"
                      optionLabel="fullName"></p-select>
        </div>
        <div class="col">
          <label class="block font-bold mb-2">Modified</label>
          <div *ngIf="evidenceCentralItem.modifiedBy">{{ evidenceCentralItem.modifiedDate | date : 'MM/dd/yyyy' }}
            by {{ evidenceCentralItem.modifiedBy }}
          </div>
        </div>
        <div class="col">
          <i class="pi pi-bolt"
             (click)="inputTestFile.click()"
             matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}">
          </i>
          <input #inputTestFile
                 type="file"
                 accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                 (change)="testAttachment($event)"
                 [style.display]="'none'">
        </div>
      </div>
    </div>

    <div *ngIf="isIntegration">
      <p-divider align="left">
        <div class="inline-flex align-items-center">
          <b>Schedule settings</b>
        </div>
      </p-divider>
      <div class="px-2">
        <scheduler
          [scheduleForm]="form.get('schedule')"
          [schedule]="evidenceCentralItem.schedule"
        ></scheduler>
      </div>
    </div>
  </div>

  <div class="p-dialog-footer flex gap-2 justify-content-end">
    <p-button type="submit" label="Save" outlined="true"></p-button>
    <p-button
      label="Cancel"
      outlined="true"
      severity="secondary"
      (click)="onClose()"
    ></p-button>
  </div>
</form>
